import { jsx as i, jsxs as m } from "react/jsx-runtime";
import { useRef as u, useState as N, useMemo as v, useEffect as R, createContext as F, useContext as C } from "react";
import { useSize as p } from "../hooks/useSize.js";
import { LightDarkImage as z } from "../LightDarkImage/LightDarkImage.js";
import D from "../_virtual/badge-check.js";
import E from "../_virtual/x.js";
import B from "./icon-default-dark.svg.js";
import j from "./icon-default-light.svg.js";
import { cx as l } from "../apps/ui/styled-system/css/cx.js";
import { css as e } from "../apps/ui/styled-system/css/css.js";
const w = F(null);
function x({
  children: t,
  colorScheme: d = "light dark",
  mode: r,
  onClose: o,
  onHeight: c,
  site: b,
  visible: y = !0
}) {
  const h = u(null), [f, k] = N(!1);
  p(h, ({ width: n }) => k(n >= 480));
  const a = v(() => {
    const n = typeof r == "string" ? { name: r, variant: "auto" } : { ...r };
    if (n.name === "dialog" && n.variant === "auto")
      return { name: "dialog", variant: f ? "floating" : "drawer" };
    if (n.name === "full" && n.variant === "auto")
      return { name: "full", variant: f ? "large" : "medium" };
    if (n.variant === "auto")
      throw new Error("Failed to resolve frame mode variant");
    return n;
  }, [r, f]), _ = u(null), g = u(null);
  p(
    g,
    ({ width: n, height: s }) => {
      s === 0 || n === 0 || (a.name === "dialog" && (c == null || c(
        s + 33 + // 32px + 1px border for the frame bar in dialog mode
        2
      )), a.name === "full" && a.variant === "content-height" && (c == null || c(
        s + (n >= 480 ? 60 : n >= 380 ? 48 : 40) + // frame bar height
        2
      )));
    },
    [c, a]
  );
  const I = v(() => {
    if (a.name === "full")
      return { colorScheme: d, mode: "full", variant: a.variant };
    if (a.name === "dialog")
      return { colorScheme: d, mode: "dialog", variant: a.variant };
    throw new Error("Failed to resolve frame context value");
  }, [d, a]);
  return R(() => {
    if (!o) return;
    const n = (s) => {
      s.key === "Escape" && o();
    };
    return window.addEventListener("keydown", n), () => window.removeEventListener("keydown", n);
  }, [o]), /* @__PURE__ */ i(w.Provider, { value: I, children: /* @__PURE__ */ i(
    "div",
    {
      className: l(
        e({
          containerType: "inline-size",
          display: "grid",
          height: "100%",
          placeItems: "center",
          position: "relative",
          width: "100%"
        }),
        a.name === "dialog" && a.variant === "drawer" && e({
          alignItems: "flex-end"
        })
      ),
      "data-dialog": a.name === "dialog" ? !0 : void 0,
      ref: h,
      style: {
        colorScheme: d,
        display: y ? void 0 : "none"
      },
      children: /* @__PURE__ */ m(
        "div",
        {
          className: l(
            e({
              display: "grid",
              height: "100%",
              overflowX: "auto",
              overflowY: a.name === "dialog" || a.name === "full" && a.variant !== "content-height" ? "auto" : "hidden",
              width: "100%"
            }),
            a.name === "dialog" && a.variant === "drawer" ? e({ placeItems: "end center" }) : e({ placeItems: "start center" })
          ),
          children: [
            a.name === "dialog" && // biome-ignore lint/a11y/noStaticElementInteractions: this is an optional way to close the dialog with a pointer
            /* @__PURE__ */ i(
              "div",
              {
                className: e({
                  background: "rgba(0, 0, 0, 0.5)",
                  inset: 0,
                  position: "fixed"
                }),
                onClick: o
              }
            ),
            /* @__PURE__ */ m(
              "div",
              {
                className: l(
                  e({
                    display: "flex",
                    flexDirection: "column",
                    minWidth: 360,
                    position: "relative",
                    width: "100%"
                  }),
                  a.name === "dialog" && e({
                    backgroundColor: "var(--background-color-th_base)",
                    border: "1px solid var(--border-color-th_frame)",
                    borderRadius: "var(--radius-th_frame)",
                    flex: 1,
                    overflow: "hidden"
                  }),
                  a.name === "dialog" && a.variant === "drawer" && e({
                    borderBottom: 0,
                    borderBottomRadius: 0,
                    maxWidth: 460
                  }),
                  a.name === "dialog" && a.variant === "floating" && e({
                    maxWidth: 360,
                    top: 16
                  }),
                  a.name === "full" && e({
                    "@container (min-width: 480px)": {
                      backgroundColor: "var(--background-color-th_base-plane)"
                    },
                    backgroundColor: "var(--background-color-th_base)"
                  }),
                  a.name === "full" && a.variant !== "content-height" && e({
                    height: "100%"
                  })
                ),
                children: [
                  /* @__PURE__ */ i(L, { mode: a, onClose: o, site: b }),
                  /* @__PURE__ */ i(
                    "div",
                    {
                      className: l(
                        e({
                          display: "flex",
                          flex: "1 0 auto",
                          justifyContent: "center",
                          width: "100%"
                        }),
                        a.name === "full" && e({
                          "@container (min-width: 480px)": {
                            alignItems: "center",
                            paddingBottom: 60
                          }
                        })
                      ),
                      children: /* @__PURE__ */ i(
                        "div",
                        {
                          className: l(
                            e({
                              display: "flex",
                              flexDirection: "column",
                              position: "relative",
                              width: "100%"
                            }),
                            a.name === "full" && e({
                              "@container (min-width: 480px)": {
                                backgroundColor: "var(--background-color-th_base)",
                                border: "1px solid var(--border-color-th_frame)",
                                borderRadius: "var(--radius-th_large)",
                                maxWidth: 400
                              },
                              overflow: "hidden"
                            })
                          ),
                          ref: _,
                          children: /* @__PURE__ */ i(
                            "div",
                            {
                              className: l(
                                e({
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%"
                                }),
                                a.name === "full" && a.variant !== "content-height" && e({
                                  height: "100%"
                                })
                              ),
                              ref: g,
                              children: t
                            }
                          )
                        }
                      )
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  ) });
}
function L({
  mode: t,
  onClose: d,
  site: r
}) {
  const o = typeof r.icon == "string" ? [r.icon, r.icon] : r.icon ?? [j, B];
  return /* @__PURE__ */ m(
    "div",
    {
      className: l(
        e({
          alignItems: "center",
          borderBottom: "1px solid var(--border-color-th_frame)",
          color: "var(--text-color-th_frame)",
          display: "flex",
          flex: "0 0 auto",
          justifyContent: "space-between",
          userSelect: "none",
          whiteSpace: "nowrap",
          width: "100%"
        }),
        t.name === "dialog" && e({
          backgroundColor: "var(--background-color-th_frame)",
          height: 33
          // 32 + 1px border
        }),
        t.name === "full" && e({
          "@container (min-width: 380px)": {
            height: 48
          },
          "@container (min-width: 480px)": {
            borderBottom: "none",
            height: 60
          },
          height: 40
        })
      ),
      children: [
        /* @__PURE__ */ i(
          "div",
          {
            className: l(
              e({
                alignItems: "center",
                display: "flex",
                flex: 1,
                minWidth: 0
              }),
              t.name === "dialog" && e({
                paddingInline: 12
              }),
              t.name === "full" && e({
                "@container (min-width: 480px)": {
                  paddingInline: 20
                },
                paddingInline: 12
              })
            ),
            children: /* @__PURE__ */ m(
              "div",
              {
                className: l(
                  e({
                    "--icon-radius": "var(--radius-th_small)",
                    "--icon-size": "20px",
                    alignItems: "center",
                    display: "flex",
                    flexShrink: 0,
                    fontSize: 13,
                    gap: 8
                  }),
                  t.name === "full" && e({
                    "@container (min-width: 480px)": {
                      "--icon-radius": "var(--radius-th_medium)",
                      "--icon-size": "28px",
                      fontSize: 15
                    }
                  })
                ),
                children: [
                  /* @__PURE__ */ i(
                    "div",
                    {
                      className: e({
                        borderRadius: "var(--icon-radius)",
                        height: "var(--icon-size)",
                        overflow: "hidden",
                        width: "var(--icon-size)"
                      }),
                      children: /* @__PURE__ */ i(
                        z,
                        {
                          dark: o[1],
                          height: 28,
                          light: o[0],
                          width: 28
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ m("div", { children: [
                    /* @__PURE__ */ i("div", { hidden: t.name === "full", children: r.label }),
                    /* @__PURE__ */ i("div", { hidden: t.name === "dialog", children: r.labelExtended ?? r.label })
                  ] }),
                  r.verified && /* @__PURE__ */ i(
                    "div",
                    {
                      className: e({
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center"
                      }),
                      children: /* @__PURE__ */ i(
                        D,
                        {
                          className: e({
                            color: "var(--color-th_accent)",
                            height: 16,
                            width: 16
                          })
                        }
                      )
                    }
                  ),
                  r.tag && /* @__PURE__ */ i(
                    "div",
                    {
                      className: e({
                        alignItems: "center",
                        backgroundColor: "var(--background-color-th_badge)",
                        borderRadius: 10,
                        color: "var(--text-color-th_badge)",
                        display: "flex",
                        fontSize: 11,
                        height: 20,
                        paddingInline: 5
                      }),
                      children: r.tag
                    }
                  )
                ]
              }
            )
          }
        ),
        d && /* @__PURE__ */ i(
          "button",
          {
            className: l(
              e({
                _active: {
                  transform: "translateY(1px)"
                },
                _focusVisible: {
                  outline: "2px solid var(--color-th_focus)",
                  outlineOffset: -2
                },
                alignItems: "center",
                background: "transparent",
                border: "none",
                cursor: "pointer!",
                display: "flex",
                height: "100%",
                padding: "0 12px"
              }),
              t.name === "full" && e({
                "@container (min-width: 480px)": {
                  padding: "0 20px"
                }
              }),
              t.name === "dialog" && e({
                borderTopRightRadius: "var(--radius-th_frame)",
                height: "100%",
                paddingInline: "6px 12px"
              })
            ),
            onClick: d,
            title: "Close Dialog",
            type: "button",
            children: /* @__PURE__ */ i(
              E,
              {
                className: e({
                  color: "var(--color-th_frame)",
                  height: 18,
                  width: 18
                })
              }
            )
          }
        )
      ]
    }
  );
}
((t) => {
  function d(r) {
    const o = C(w);
    if (!o && !r)
      throw new Error("useFrame must be used within a Frame context");
    return o;
  }
  t.useFrame = d;
})(x || (x = {}));
export {
  x as Frame
};
//# sourceMappingURL=Frame.js.map
